import { Permissions } from './index';
import { EVENTS_ENABLED } from './features';
import {
    DashboardOutlined,
    PeopleAltOutlined,
    PersonOutlined,
    BadgeOutlined,
    ApartmentOutlined,
    LocalOfferOutlined,
    FormatListBulletedOutlined,
    CategoryOutlined,
    HistoryOutlined,
    AdminPanelSettingsOutlined,
    GroupsOutlined,
    EventOutlined,
    GroupAddOutlined,
    LoginOutlined,
    ErrorOutline,
    SecurityOutlined,
    HttpOutlined,
} from '@mui/icons-material';

export default function menus() {
    const userStore = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    const singleGroupPath =
        userStore.groups && userStore.groups.length === 1
            ? `/group/${userStore.groups[0].id}`
            : '/groups';

    const validCompanyIds = userStore.companyIds?.filter(Boolean) ?? [];
    const singleCompanyPath =
        validCompanyIds.length === 1 ? `/company/${validCompanyIds[0]}` : '/companies';

    return [
        {
            path: '/',
            name: 'menu.dashboard',
            icon: DashboardOutlined,
            state: 'DashCollapse',
            permission: [Permissions.DASHBOARD_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
        },
        {
            collapse: true,
            name: 'menu.users',
            icon: PeopleAltOutlined,
            state: 'userCollapse',
            permission: [
                Permissions.APP_USER_VIEW,
                Permissions.COMPANY_USER_VIEW,
                Permissions.SPECIAL_USER_VIEW,
            ],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                {
                    path: '/app-users',
                    name: 'menu.app_users',
                    icon: PersonOutlined,
                    mini: 'AU',
                    permission: [Permissions.APP_USER_VIEW],
                },
                {
                    redirect: true,
                    path: '/app-users/new',
                    name: 'menu.add_user',
                    icon: PersonOutlined,
                    mini: 'AU',
                    permission: [Permissions.APP_USER_CREATE, Permissions.APP_USER_UPDATE],
                },
                {
                    redirect: true,
                    path: '/user-profile',
                    name: 'menu.user_profile',
                    icon: PersonOutlined,
                    mini: 'UP',
                    permission: [Permissions.APP_USER_DETAILS],
                },
                {
                    path: '/company-user',
                    name: 'menu.company_users',
                    icon: BadgeOutlined,
                    mini: 'CU',
                    permission: [Permissions.COMPANY_USER_VIEW],
                },
                {
                    redirect: true,
                    path: '/add-company-user',
                    name: 'menu.add_company_users',
                    icon: BadgeOutlined,
                    mini: 'CU',
                    permission: [Permissions.COMPANY_USER_CREATE, Permissions.COMPANY_USER_UPDATE],
                },
            ],
        },
        {
            collapse: true,
            name: 'menu.groups',
            icon: GroupsOutlined,
            state: 'groupsCollapse',
            permission: [Permissions.SPECIAL_USER_VIEW, Permissions.GROUP_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                {
                    path: '/groups',
                    name: 'menu.list_groups',
                    icon: GroupsOutlined,
                    mini: 'GL',
                    permission: [Permissions.GROUP_VIEW],
                },
                {
                    redirect: true,
                    path: '/add-group',
                    name: 'group.add_new',
                    icon: GroupsOutlined,
                    mini: 'GL',
                    permission: [Permissions.GROUP_CREATE],
                },
                {
                    path: '/groups/members',
                    name: 'menu.members',
                    icon: PeopleAltOutlined,
                    mini: 'GM',
                    permission: [Permissions.SPECIAL_USER_VIEW],
                },
            ],
        },
        {
            collapse: true,
            path: '/companies',
            name: 'menu.companies',
            icon: ApartmentOutlined,
            state: 'companiesCollapse',
            permission: [Permissions.COMPANY_VIEW, Permissions.CATEGORY_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                {
                    path: '/companies',
                    name: 'menu.list_of_companies',
                    icon: ApartmentOutlined,
                    mini: 'CS',
                    permission: [Permissions.COMPANY_VIEW],
                },
                {
                    path: '/company-categories',
                    name: 'menu.categories',
                    icon: CategoryOutlined,
                    mini: 'CC',
                    permission: [Permissions.CATEGORY_VIEW],
                },
                // {
                //   redirect: true,
                //   path: add-company-user || "/app/add-company" conflict ,
                //   name: "menu.add_company",
                //   icon: ListAlt,
                //   mini: "AC",
                //   permission: [
                //     Permissions.COMPANY_CREATE,
                //     Permissions.COMPANY_UPDATE,
                //   ],
                // },
            ],
        },
        {
            collapse: true,
            path: '/offers',
            name: 'menu.offers',
            icon: LocalOfferOutlined,
            state: 'offerCollapse',
            permission: [Permissions.OFFER_VIEW, Permissions.CATEGORY_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                {
                    path: '/offers',
                    name: 'menu.list_of_offers',
                    icon: LocalOfferOutlined,
                    mini: 'AU',
                    permission: [Permissions.OFFER_VIEW],
                },
                {
                    path: '/offer-categories',
                    name: 'menu.categories',
                    icon: CategoryOutlined,
                    mini: 'AU',
                    permission: [Permissions.CATEGORY_VIEW],
                },
                {
                    redirect: true,
                    path: '/offers/new',
                    name: 'menu.add_offer',
                    icon: LocalOfferOutlined,
                    mini: 'AO',
                    permission: [
                        Permissions.OFFER_CREATE,
                        Permissions.OFFER_UPDATE,
                        Permissions.CU_OFFER_CREATE,
                        Permissions.CU_OFFER_UPDATE,
                    ],
                },
            ],
        },
        {
            path: '/events',
            name: 'menu.events',
            icon: EventOutlined,
            state: 'Events',
            permission: [Permissions.EVENT_VIEW],
            showByCondition: (userStore) => {
                return (
                    EVENTS_ENABLED &&
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
        },
        {
            path: '/notifications',
            name: 'menu.notifications_logs',
            icon: HistoryOutlined,
            collapse: true,
            state: 'notifications_logs',
            permission: [Permissions.NOTIFICATION_VIEW, Permissions.LOG_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                // {
                //   path: "/notifications",
                //   name: "menu.notifications",
                //   icon: ListAlt,
                //   mini: "NA",
                //   permission: [
                //     Permissions.NOTIFICATION_VIEW
                //   ],
                // },
                {
                    path: '/logs',
                    name: 'menu.logs',
                    icon: HistoryOutlined,
                    mini: 'AL',
                    permission: [Permissions.LOG_VIEW],
                },
                {
                    path: '/logins',
                    name: 'menu.logins',
                    icon: LoginOutlined,
                    mini: 'AL',
                    permission: [Permissions.ACTIVITY_LOGIN_VIEW],
                },
                {
                    path: '/job-batches',
                    name: 'menu.job_batches',
                    icon: FormatListBulletedOutlined,
                    mini: 'JB',
                    permission: [Permissions.LOG_VIEW],
                    showByCondition: (userStore) => {
                        return userStore.roles && userStore.roles.includes('super_admin');
                    },
                },
                {
                    path: '/failed-jobs',
                    name: 'menu.failed_jobs',
                    icon: ErrorOutline,
                    mini: 'FJ',
                    permission: [Permissions.LOG_VIEW],
                    showByCondition: (userStore) => {
                        return userStore.roles && userStore.roles.includes('super_admin');
                    },
                },
                {
                    path: '/security-events',
                    name: 'menu.security_events',
                    icon: SecurityOutlined,
                    mini: 'SE',
                    permission: [Permissions.LOG_VIEW],
                    showByCondition: (userStore) => {
                        return userStore.roles && userStore.roles.includes('super_admin');
                    },
                },
                {
                    path: '/public-api-audit-logs',
                    name: 'menu.public_api_audit_logs',
                    icon: HttpOutlined,
                    mini: 'PA',
                    permission: [Permissions.PUBLIC_API_AUDIT_VIEW],
                    showByCondition: (userStore) => {
                        return userStore.roles && userStore.roles.includes('super_admin');
                    },
                },
                {
                    path: '/push-notifications',
                    name: 'menu.push_notifications',
                    icon: FormatListBulletedOutlined,
                    mini: 'PN',
                    permission: [Permissions.LOG_VIEW],
                    showByCondition: (userStore) => {
                        return userStore.roles && userStore.roles.includes('super_admin');
                    },
                },
            ],
        },

        {
            collapse: true,
            path: '/roles',
            name: 'menu.user_management',
            icon: AdminPanelSettingsOutlined,
            state: 'aclCollapse',
            permission: [Permissions.ROLE_VIEW, Permissions.PERMISSION_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    !userStore.roles.includes('company_user') &&
                    !userStore.roles.includes('group_admin')
                );
            },
            views: [
                {
                    path: '/roles',
                    name: 'menu.roles',
                    icon: AdminPanelSettingsOutlined,
                    mini: 'R',
                    permission: [Permissions.ROLE_VIEW],
                },
                {
                    path: '/permissions',
                    name: 'menu.permissions',
                    icon: FormatListBulletedOutlined,
                    mini: 'P',
                    permission: [Permissions.PERMISSION_VIEW],
                },
            ],
        },

        {
            path: '/',
            name: 'menu.dashboard',
            icon: DashboardOutlined,
            state: 'CUDashCollapse',
            permission: [Permissions.CU_DASHBOARD_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    (userStore.roles.includes('company_user') ||
                        userStore.roles.includes('group_admin'))
                );
            },
        },

        {
            path: '/company-user',
            name: 'menu.company_users',
            icon: BadgeOutlined,
            mini: 'CompanyUsers',
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    (userStore.roles.includes('company_user') ||
                        userStore.roles.includes('group_admin'))
                );
            },
        },

        {
            collapse: true,
            name: 'menu.groups',
            icon: GroupsOutlined,
            state: 'cu_group',
            defaultOpen: true,

            permission: [Permissions.CU_GROUP_UPDATE, Permissions.CU_EMPLOYEE_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    (userStore.roles.includes('company_user') ||
                        userStore.roles.includes('group_admin'))
                );
            },
            views: [
                {
                    path: singleGroupPath,
                    name: 'menu.my_group',
                    icon: GroupsOutlined,
                    state: 'CUMyGroupCollapse',
                    permission: [Permissions.CU_GROUP_UPDATE],
                },
                {
                    path: '/groups/members',
                    name: 'menu.my_employees',
                    icon: PeopleAltOutlined,
                    state: 'CUEmployees',
                    permission: [Permissions.CU_EMPLOYEE_VIEW],
                },
            ],
        },

        // {
        //     custom: true,
        //     path: "/my_members",
        //     name: "menu.my_employees",
        //     icon: SupervisorAccount,
        //     state: "CUEmployees",
        //     permission: [Permissions.CU_CUSTOM_EMPLOYEE_VIEW],
        // },

        {
            path: singleCompanyPath,
            name: 'menu.my_companies',
            icon: ApartmentOutlined,
            state: 'CUCompanies',
            showByCondition: (userStore) => {
                const companyIds = userStore.companyIds?.filter(Boolean) ?? [];
                return (
                    companyIds.length > 0 &&
                    userStore.roles &&
                    (userStore.roles.includes('company_user') ||
                        userStore.roles.includes('group_admin'))
                );
            },
        },
        {
            path: '/offers',
            name: 'menu.my_offers',
            icon: LocalOfferOutlined,
            state: 'CUOffers',
            permission: [Permissions.CU_OFFER_VIEW],
            showByCondition: (userStore) => {
                return (
                    userStore.roles &&
                    (userStore.roles.includes('company_user') ||
                        userStore.roles.includes('group_admin'))
                );
            },
        },
        {
            path: '/events',
            name: 'menu.events',
            icon: EventOutlined,
            state: 'CUEvents',
            permission: [Permissions.EVENT_VIEW],
            showByCondition: (userStore) => {
                return (
                    EVENTS_ENABLED &&
                    userStore.roles &&
                    userStore.roles.includes('group_admin')
                );
            },
        },
        // {
        //     path: '/offers',
        //     name: 'menu.offers',
        //     icon: Ballot,
        //     state: 'CUOffers',
        //     permission: [Permissions.CU_OFFER_VIEW],
        //     showByCondition: (userStore) => {
        //         return (
        //             userStore.roles &&
        //             (userStore.roles.includes('company_user') ||
        //                 userStore.roles.includes('group_admin'))
        //         );
        //     },
        // },
        // {
        //     path: "/b2b",
        //     name: "menu.b2b_offers",
        //     icon: ListAlt,
        //     state: "CUB2B",
        //     permission: [Permissions.CU_B2B_VIEW],
        // },
    ];
}
